// extracted by mini-css-extract-plugin
export default {"title":"laa-z","warning":"maa-z","sizeOptionsLegendText":"naa-z"};